// extracted by mini-css-extract-plugin
export default {"root":"partners-list-item_root__6vmi5","link":"partners-list-item_link__FqnM7","logo":"partners-list-item_logo__5MYV9"};